import { LucideSparkles } from 'lucide-react';

import { cn } from '@/utils/tailwind';

export const EmptyTraceSplash = (props: { className?: string | undefined }) => (
  <div
    className={cn(
      props.className,
      'flex h-full flex-col items-center justify-center bg-background',
      'border-t border-secondary'
    )}
  >
    <div className="border-1 mb-4 rounded-2xl border border-secondary p-5">
      <LucideSparkles className="text-tertiary" />
    </div>
    <span className="text-lg font-medium text-ls-black">New Thread</span>
    <span className="mt-2 text-sm text-tertiary">
      Submit your input to run the assistant
    </span>
  </div>
);
